"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// reminder to not import AppUI to avoid circular dependencies
var USER_DATA_ACCESS_LEVELS = ['basic', 'complete'];
var BASIC_INDEX = USER_DATA_ACCESS_LEVELS.indexOf('basic');
var COMPLETE_INDEX = USER_DATA_ACCESS_LEVELS.indexOf('complete');
var Permissions = /*#__PURE__*/function () {
  function Permissions(userGroup) {
    _classCallCheck(this, Permissions);
    this.userGroup = userGroup;
    this.userDataAccessLevelIndex = USER_DATA_ACCESS_LEVELS.indexOf(this.userGroup.userDataAccessLevel);
  }
  return _createClass(Permissions, [{
    key: "isAtLeastBasic",
    get:
    // Basic queries

    function get() {
      return this.userDataAccessLevelIndex >= BASIC_INDEX;
    }
  }, {
    key: "isComplete",
    get: function get() {
      return this.userDataAccessLevelIndex === COMPLETE_INDEX;
    }
  }, {
    key: "canAccessBasicUserData",
    get: function get() {
      return this.isAtLeastBasic;
    }

    // Domain-specific queries
  }, {
    key: "canAccessAdmins",
    get: function get() {
      return this.isComplete;
    }
  }, {
    key: "canAccessUserEmails",
    get: function get() {
      return this.isComplete;
    }
  }], [{
    key: "userDataAccessLevelForSelect",
    get: function get() {
      return [''].concat(USER_DATA_ACCESS_LEVELS).map(function (item) {
        return [item, item === '' ? 'none' : item];
      });
    }
  }]);
}();
var _default = exports["default"] = Permissions;